export const resturls = {
  registerWebsiteUser: "websiteEnrolledUser/registerWebsiteUser",
};
